import { IMoment } from '@lib/moment';
import { IServerGetParams } from './notifications.service';

interface IAction {
  redirectUri: string;
  isQueryParam?: boolean;
  queryParams?: {
    [key: string]: string;
  }
}

export interface INotification {
  id: number;
  read: boolean;
  seen: boolean;
  text: string;
  subtext?: string;
  type: string;
  priority: boolean;
  createdAt: IMoment;
  action: IAction;
}

export enum FILTER_TYPE {
  ALL = 'ALL',
  IMPORTANT = 'IMPORTANT',
}

export interface IFilterType {
  id: FILTER_TYPE;
  text: string;
  hidePriority: boolean;
  params: IServerGetParams;
  notificationIds: Set<number>;
  hasReceivedInitialData?: boolean;
  isFullyLoaded: boolean;
}
